import { Drawer } from '@theme/drawer';

/**
 * Mobile menu drawer. Trigger button lives in the header (dispatches
 * `menu:open`); the panel lives at body level to escape the header
 * section's transform stacking context.
 */
class HeaderDrawer extends Drawer {
  setup() {
    super.setup();
    document.addEventListener('menu:open', () => this.open());
  }

  get trigger() {
    return document.getElementById('mobile-menu-toggle');
  }

  open() {
    super.open();
    this.trigger?.setAttribute('aria-expanded', 'true');
  }

  close() {
    if (!this.isOpen) return;
    super.close();
    this.trigger?.setAttribute('aria-expanded', 'false');
    this.trigger?.focus();
  }
}

customElements.define('header-drawer', HeaderDrawer);

export { HeaderDrawer };
